import { Button, ButtonSize, ButtonType, Dialog } from "@yy/tofu-ui-react";
import React, { useEffect, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { ModalRoutes } from "./ModalSwitch";
import { stat } from "../../lib/hooks/useHiidoPV";

export const GuildInfoFormModal = () => {
  const history = useHistory();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // 跳过或完成填写
  const skip = useCallback(() => {
    // 数据上报
    stat.emit({ eventid: 20030927, act_type: "203" });

    history.replace(ModalRoutes.ChooseGuildType);
  }, [history]);

  const submit = () => {
    // 数据上报
    stat.emit({ eventid: 20030927, act_type: "202" });

    let iframe = iframeRef.current;
    if (iframe) {
      iframe.contentWindow?.postMessage({ msg: "submitGuildInfoForm" }, "*");
    }
  };

  useEffect(() => {
    const onMessage = ({ data }: any) => {
      if (data.msg === "submitGuildInfoFormCb") {
        skip();
      }
    };
    window.addEventListener("message", onMessage, false);
    return () => {
      window.removeEventListener("message", onMessage, false);
    };
  }, [skip]);

  return (
    <Dialog
      wrapperStyle={{ width: 840, height: 700 }}
      title=""
      active
      className="beGuildInfo-dialog"
      showCancelBtn={false}
      showConfirmBtn={false}
      onCancel={() => history.replace(ModalRoutes.Root)}
    >
      <iframe
        title="公会资料页填写"
        width="840"
        height="613"
        src="//www.yy.com/web/beGuild_information/"
        ref={iframeRef}
      />
      <div className="btns-group">
        <Button type={ButtonType.Emphasis} size={ButtonSize.L} onClick={submit}>
          提交
        </Button>
        <Button size={ButtonSize.L} onClick={skip}>
          跳过
        </Button>
      </div>
    </Dialog>
  );
};

export default GuildInfoFormModal;
